import React from 'react';
import { LabeledElement } from 'components/form-elements/labels/LabeledElement';
import { WeekdayPicker } from '../WeekdayPicker';

export const LabeledWeekdayPicker = ({ title, onClick, selectedDays, className, disabledDays }) => (

  <LabeledElement
    label={title}
  >
    <WeekdayPicker
      onClick={onClick}
      selectedDays={selectedDays}
      className={className}
      disabledDays={disabledDays}
    />
  </LabeledElement>
);
